import React from 'react';
import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { Row, Col, Button } from "reactstrap";
import axios from "axios";
import Sidebar from '../../Sidebar';
import { useNavigate } from 'react-router';
import { BiSave } from "react-icons/bi";
import { IoIosEye } from "react-icons/io";
import { TiCancel } from "react-icons/ti";
import { AiOutlineHome } from "react-icons/ai";
import { useCookies } from 'react-cookie';
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
import { moment } from 'moment';
import { useLocation, Link } from 'react-router-dom';
import {displayErrorToast,displayError} from '../../helpers';
import ErrorToast from '../../ErrorToast';
import { getUserAllowedPlants} from '../../services/PlantServices';
import { createMoisture, getMoistureDailyCount, getMcNumber } from "../../services/MoistureCorrectionServices";
import FloatingControls from '../../components/FloatingControls';
import LoadingOverlay from '../../components/LoadingOverlay';
import PremiumPageHeader from '../../components/PremiumPageHeader';
import { confirmMoistureSoftLimit, formatMoistureDailyCount } from '../../utils/moistureCorrectionUtils';
import { getCurrentDate, getCurrentTime } from '../../utils/DateUtils';

function MoistureCorrection() {
const [category] = useCookies(['myCategory']);
const [plants, setPlants] = React.useState([]);
const [error, setError] = useState({});
const [isSubmitting, setIsSubmitting] = useState(true);
const [superuser] = useCookies(['mySuperuser']);
const [cookies] = useCookies(['myToken']);
const [inProgress, setInProgress] = useState(false);
const [dailyCountMeta, setDailyCountMeta] = useState(null);

const [inputs, setInputs] = useState({
  "plant_id":"",
  "moisture_msand": 0,
  "moisture_csand": 0,
  "moisture_rsand":0,
  "moisture_12mm": 0,
  "moisture_20mm":0,
   "absorption_msand": 0,
  "absorption_csand": 0,
  "absorption_rsand": 0,
  "absorption_12mm": 0,
  "absorption_20mm": 0,
  "correction_factor_msand": 0,
  "correction_factor_csand": 0,
  "correction_factor_rsand": 0,
  "correction_factor_12mm": 0,
  "correction_factor_20mm": 0,
  "mc_no": "",
  "mc_date": getCurrentDate(),
  "mc_time": getCurrentTime(),
  "is_active": true,
});

React.useEffect(() => {

    getUserAllowedPlants(cookies)
        .then(response => {

            if (!response || !response.plant_list) {
                console.error("Invalid plant list response:", response);
                setPlants([]);
                return;
            }

            console.log("Plant List:", response);

            const plantOptions = response.plant_list
                .filter(p => p.status === true)
                .map(p => ({
                    value: p.id,
                    label: p.plant_alias
                }));

            setPlants(plantOptions);
        })
        .catch(error => {
            console.error("Error loading plants:", error);
            displayErrorToast("Unable to load plant list");
            setPlants([]);
        });

}, []);


React.useEffect(() => {
  if (!inputs.plant_id) {
    setDailyCountMeta(null);
    return;
  }
  getMoistureDailyCount(cookies, inputs.plant_id)
    .then(setDailyCountMeta)
    .catch(() => setDailyCountMeta(null));
}, [cookies, inputs.plant_id]);

const refreshMcPreview = (plantId, mcDate, mcTime) => {
  if (!plantId) {
    return;
  }
  getMcNumber(cookies, plantId, mcDate, mcTime)
    .then((meta) => {
      setInputs((values) => ({
        ...values,
        mc_no: meta.mc_no || values.mc_no,
        mc_date: meta.mc_date || values.mc_date,
        mc_time: (meta.mc_time || values.mc_time || '').slice(0, 5),
      }));
    })
    .catch(() => {});
};

React.useEffect(() => {
  if (!inputs.plant_id) {
    return;
  }
  refreshMcPreview(inputs.plant_id, inputs.mc_date, inputs.mc_time);
}, [cookies, inputs.plant_id]);


  const navigate = useNavigate();

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    try {
        // Handle plant selection
        if(name === "plant_id") {
            const plantId = parseInt(value);
            setInputs(values => ({ ...values, [name]: plantId }));
            refreshMcPreview(plantId, inputs.mc_date || getCurrentDate(), inputs.mc_time || getCurrentTime());
            return;
        }

        if (name === 'mc_date' || name === 'mc_time') {
            const updatedInputs = { ...inputs, [name]: value };
            setInputs(updatedInputs);
            if (updatedInputs.plant_id) {
              refreshMcPreview(updatedInputs.plant_id, updatedInputs.mc_date, updatedInputs.mc_time);
            }
            return;
        }

        let updatedInputs = { ...inputs, [name]: value };

        // Calculate correction factors automatically
        const pairs = [
            ["msand", "moisture_msand", "absorption_msand", "correction_factor_msand"],
            ["csand", "moisture_csand", "absorption_csand", "correction_factor_csand"],
            ["rsand", "moisture_rsand", "absorption_rsand", "correction_factor_rsand"],
            ["12mm", "moisture_12mm", "absorption_12mm", "correction_factor_12mm"],
            ["20mm", "moisture_20mm", "absorption_20mm", "correction_factor_20mm"]
        ];

        pairs.forEach(([key, moistureKey, absorptionKey, cfKey]) => {
            if(name === moistureKey || name === absorptionKey) {
                const moisture = parseFloat(updatedInputs[moistureKey]) || 0;
                const absorption = parseFloat(updatedInputs[absorptionKey]) || 0;
                updatedInputs[cfKey] = (moisture - absorption).toFixed(2);
            }
        });

        setInputs(updatedInputs);

    } catch(e) {
        displayErrorToast(e);
    }
};


const handleSubmit = async (event) => {
  event.preventDefault();
  if ((Object.values(error).every(x => !x)) && isSubmitting) {
    const canProceed = await confirmMoistureSoftLimit(cookies, inputs.plant_id, 'save');
    if (!canProceed) {
      return;
    }
    Swal.fire({
      title: 'Do you want to save?',  
      showCancelButton: true,  
      confirmButtonText: `Yes`,  
      cancelButtonText: `No`,
    }).then((result) => {  
      if (result.isConfirmed) { 
        createMoisture(cookies, {
          plant: parseInt(inputs.plant_id),
          mc_date: inputs.mc_date,
          mc_time: inputs.mc_time,
          moisture_msand: parseFloat(inputs.moisture_msand || 0),
          absorption_msand: parseFloat(inputs.absorption_msand || 0),
          correction_factor_msand: parseFloat(inputs.correction_factor_msand || 0),

          moisture_csand: parseFloat(inputs.moisture_csand || 0),
          absorption_csand: parseFloat(inputs.absorption_csand || 0),
          correction_factor_csand: parseFloat(inputs.correction_factor_csand || 0),

          moisture_rsand: parseFloat(inputs.moisture_rsand || 0),
          absorption_rsand: parseFloat(inputs.absorption_rsand || 0),
          correction_factor_rsand: parseFloat(inputs.correction_factor_rsand || 0),

          moisture_12mm: parseFloat(inputs.moisture_12mm || 0),
          absorption_12mm: parseFloat(inputs.absorption_12mm || 0),
          correction_factor_12mm: parseFloat(inputs.correction_factor_12mm || 0),

          moisture_20mm: parseFloat(inputs.moisture_20mm || 0),
          absorption_20mm: parseFloat(inputs.absorption_20mm || 0),
          correction_factor_20mm: parseFloat(inputs.correction_factor_20mm || 0),
          is_active: inputs.is_active !== false,
        })
        .then(response => {
          Swal.fire({
            icon: "success",
            title: "Saved",
            text: "Moisture correction saved successfully!",
          });
          Reload();
        })
        .catch(err => {

        let message = "Save failed. Please try again.";

        if (err.response) {
          if (err.response.data?.detail) {
            message = err.response.data.detail;
          } 
          else if (typeof err.response.data === "string") {
            message = err.response.data;
          }
          else if (err.response.data?.message) {
            message = err.response.data.message;
          }
        }

        Swal.fire({
          icon: "error",
          title: "Save Failed",
          text: message,
        });

      });
      } else if (result.isDismissed) {    
        Swal.fire('Not saved', '', 'info')  
      }
    });
  }
};

  const Cancel = () => {
    setInputs(() => "")
  }

  const Reload = () => {
    window.location.reload();
  } 

  const view = () => {
    navigate('/MoistureCorrectionTable')
  } 

  const Back = () => {
    navigate('/Home')
  }

return(
    <>
      <div id="outer-container" className="App" >
        <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} />
        <ErrorToast/>
        <LoadingOverlay inProgress={inProgress}/>
        <div id="page-wrap">
          <form onSubmit={handleSubmit} >
            <div className="premium-page-header-wrap">
              <PremiumPageHeader
                module="QUALITY CONTROL"
                title="Moisture Correction"
                subtitle="Select a plant, then enter moisture and absorption. New MC is Active by default. Deactivate older MC when a new session MC is approved."
                modeLabel="ADD MODE"
              />
              {dailyCountMeta && (
                <p className="text-center mb-0" style={{ color: dailyCountMeta.soft_limit_reached ? '#b45309' : '#1e40af', fontWeight: 600 }}>
                  {formatMoistureDailyCount(dailyCountMeta)}
                  {dailyCountMeta.soft_limit_reached ? ' — additional saves allowed with confirmation' : ''}
                </p>
              )}
            </div>
            <FloatingControls tableLink="/MoistureCorrectionTable" onCancel={Cancel} enableCancel={false}/>
            <div className="container moisture-correction-page">
              <Row>
                <Col xl={12} lg={12} md={12}>
                    <div className="form-row table-bordered shadow p-2 my-1 border-secondary p-3 mb-2 bg-blue form-control-panel" >
                      <div className="moisture-correction-meta">
                        <div className="moisture-correction-meta-left">
                          <div className="moisture-correction-meta-item mc-meta-plant">
                            <label htmlFor="plant_id">Plant</label>
                            <select
                              id="plant_id"
                              name="plant_id"
                              className="form-control mandatory-form-control"
                              required
                              onChange={(e) => setInputs({...inputs, plant_id: parseInt(e.target.value)})}
                              value={inputs.plant_id || ""}
                            >
                              <option value="">Select plant</option>
                              {plants.map((item) => (
                                <option key={item.value} value={item.value}>
                                  {item.label}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="moisture-correction-meta-item mc-meta-mcno">
                            <label>MC No.</label>
                            <input type="text" className="form-control" value={inputs.mc_no || ''} readOnly style={{ cursor: 'not-allowed' }} />
                          </div>
                          <div className="moisture-correction-meta-item mc-meta-date">
                            <label htmlFor="mc_date">Date</label>
                            <input type="date" id="mc_date" name="mc_date" className="form-control mandatory-form-control" value={inputs.mc_date || ''} onChange={handleChange} required />
                          </div>
                          <div className="moisture-correction-meta-item mc-meta-time">
                            <label htmlFor="mc_time">Time</label>
                            <input type="time" id="mc_time" name="mc_time" className="form-control mandatory-form-control" value={inputs.mc_time || ''} onChange={handleChange} required />
                          </div>
                        </div>
                        <div className="moisture-correction-meta-item mc-meta-status">
                          <label htmlFor="is_active">Status</label>
                          <select
                            id="is_active"
                            name="is_active"
                            className="form-control mandatory-form-control"
                            value={inputs.is_active === false ? 'false' : 'true'}
                            onChange={(e) => setInputs({ ...inputs, is_active: e.target.value === 'true' })}
                          >
                            <option value="true">Active</option>
                            <option value="false">Inactive</option>
                          </select>
                        </div>
                      </div>

                      <div className="w-100 mb-3"></div>   {/* <<< adds space */}

                      <span className="col-sm-1"></span>
                      <h5 className="col-sm-3 text-center"><b>Moisture (%)</b></h5>
                      <span className="col-sm-1"></span>
                      <h5 className="col-sm-3 text-center"><b>Absorption (%)</b></h5>
                      <span className="col-sm-1"></span>
                      <h5 className="col-sm-3 text-center"><b>Correction Factor (%)</b></h5>
                         
                      <label htmlFor="moisture_msand" className="form-group col-sm-1 text-left">MSAND </label>
                      <input type="number" step="any" id="moisture_msand" onChange={handleChange} value={inputs.moisture_msand || 0} name="moisture_msand" max="15" min="0" className="form-control col-sm-3 mandatory-form-control"  pattern="[0-9]*" required/><br/><br/>
                      <label htmlFor="absorption_msand" className="form-group col-sm-1 text-right">&nbsp;  </label>
                      <input type="number"  step="any" id="absorption_msand" onChange={handleChange} value={inputs.absorption_msand || 0} name="absorption_msand" max="5" min="0"  className="form-control col-sm-3 mandatory-form-control"  pattern="[0-9]*" required/><br/><br/>
                      <label htmlFor="correction_factor_msand" className="form-group col-sm-1 text-right">&nbsp;  </label>
                      <input type="number" id="correction_factor_msand"  value={inputs.correction_factor_msand || 0} name="correction_factor_msand" className="form-control col-sm-3" readOnly={true} style={{cursor: "not-allowed"}}   pattern="[0-9]*" required/><br/><br/>

                      <label htmlFor="moisture_csand" className="form-group col-sm-1 text-right">CSAND </label>
                      <input type="number" step="any"  id="moisture_csand" onChange={handleChange} value={inputs.moisture_csand || 0} name="moisture_csand" max="15" min="0"  className="form-control col-sm-3 mandatory-form-control"  pattern="[0-9]*" required/><br/><br/>
                      <label htmlFor="absorption_csand" className="form-group col-sm-1 text-right">&nbsp;  </label>
                      <input type="number" step="any"  id="absorption_csand" onChange={handleChange} value={inputs.absorption_csand || 0} name="absorption_csand" max="5"  min="0" className="form-control col-sm-3 mandatory-form-control"  pattern="[0-9]*" required/><br/><br/>
                      <label htmlFor="correction_factor_csand" className="form-group col-sm-1 text-right">&nbsp;  </label>
                      <input type="number" id="correction_factor_csand"  value={inputs.correction_factor_csand || 0} name="correction_factor_csand" readOnly={true} style={{cursor: "not-allowed"}} className="form-control col-sm-3"  pattern="[0-9]*" required/><br/><br/>

                      <label htmlFor="moisture_rsand" className="form-group col-sm-1 text-right">RSAND </label>
                      <input type="number" step="any"  id="moisture_rsand" onChange={handleChange} value={inputs.moisture_rsand || 0} name="moisture_rsand" max="15"  min="0" className="form-control col-sm-3 mandatory-form-control"  pattern="[0-9]*" required/><br/><br/>
                      <label htmlFor="absorption_rsand" className="form-group col-sm-1 text-right">&nbsp;  </label>
                      <input type="number" step="any"  id="absorption_rsand" onChange={handleChange} value={inputs.absorption_rsand || 0} name="absorption_rsand" max="5"  min="0" className="form-control col-sm-3 mandatory-form-control"  pattern="[0-9]*" required/><br/><br/> 
                      <label htmlFor="correction_factor_rsand" className="form-group col-sm-1 text-right">&nbsp;  </label>
                      <input type="number" id="correction_factor_rsand"  value={inputs.correction_factor_rsand || 0} name="correction_factor_rsand" readOnly={true} style={{cursor: "not-allowed"}} className="form-control col-sm-3"  pattern="[0-9]*" required/><br/><br/>

                      <label htmlFor="moisture_12mm" className="form-group col-sm-1 text-right">12 MM </label>
                      <input type="number" step="any"  id="moisture_12mm" onChange={handleChange} value={inputs.moisture_12mm || 0} name="moisture_12mm" max="15" min="0"  className="form-control col-sm-3 mandatory-form-control"  pattern="[0-9]*" required/><br/><br/> 
                      <label htmlFor="absorption_12mm" className="form-group col-sm-1 text-right">&nbsp;  </label>
                      <input type="number" step="any"  id="absorption_12mm" onChange={handleChange} value={inputs.absorption_12mm || 0} name="absorption_12mm" max="5"  min="0" className="form-control col-sm-3 mandatory-form-control"  pattern="[0-9]*" required/><br/><br/> 
                      <label htmlFor="correction_factor_12mm" className="form-group col-sm-1 text-right">&nbsp;  </label>
                      <input type="number" id="correction_factor_12mm"  value={inputs.correction_factor_12mm || 0} name="correction_factor_12mm" readOnly={true} style={{cursor: "not-allowed"}} className="form-control col-sm-3"  pattern="[0-9]*" required/><br/><br/>

                      <label htmlFor="moisture_20mm" className="form-group col-sm-1 text-right">20 MM </label>
                      <input type="number"  step="any" id="moisture_20mm" onChange={handleChange} value={inputs.moisture_20mm || 0} name="moisture_20mm" max="15"  min="0" className="form-control col-sm-3 mandatory-form-control"  pattern="[0-9]*" required/><br/><br/> 
                      <label htmlFor="absorption_20mm" className="form-group col-sm-1 text-right">&nbsp;  </label>
                      <input type="number"  step="any" id="absorption_20mm" onChange={handleChange} value={inputs.absorption_20mm || 0} name="absorption_20mm" max="5" min="0"  className="form-control col-sm-3 mandatory-form-control"  pattern="[0-9]*" required/><br/><br/>
                      <label htmlFor="correction_factor_20mm" className="form-group col-sm-1 text-right">&nbsp;  </label>
                      <input type="number" id="correction_factor_20mm"  value={inputs.correction_factor_20mm || 0} name="correction_factor_20mm" readOnly={true} style={{cursor: "not-allowed"}} className="form-control col-sm-3"  pattern="[0-9]*" required/><br/><br/>
                    </div>
                </Col>
              </Row>
            </div>

            <div className="footer text-center">
              <Button  type="submit" className="btn btn-twitter" style={{width:"80px",fontWeight:"bold"}} >Save</Button> &nbsp;&nbsp;
              <Button type="reset" className="btn btn-twitter" style={{width:"80px",fontWeight:"bold"}} onClick={Cancel}>Reset</Button> &nbsp;&nbsp;
              <Button className="btn btn-twitter"  type="button"style={{width:"80px",fontWeight:"bold"}} onClick={view}>View</Button>&nbsp;&nbsp;
              <Button className="btn btn-twitter"  type="button"style={{width:"80px",fontWeight:"bold"}} onClick={Back}>Home</Button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
export default MoistureCorrection;